import { Injectable } from '@angular/core';

import { LineItemListModel } from '../../models/LineItemListModel';
import { BaseApiService } from '../base-api.service';
import { UserService } from '../user/user.service';

@Injectable({
  providedIn: 'root',
})
export class LineItemListService {
  baseUrl = window.location.origin;
  token = '';

  constructor(
    private baseAPIService: BaseApiService,
    private user: UserService,
  ) {
    this.user.token.subscribe(value => {
      this.token = value;
    });
  }

  getLineItemList(): Promise<LineItemListModel[]> {
    const url = this.baseUrl + '/api/LineItemList/GetLineItemList';
    this.baseAPIService.headerToken = this.token;
    return this.baseAPIService.get<LineItemListModel[]>(url);
  }

  postFile(data: FormData) {
    const url = this.baseUrl + '/api/upload/UploadLineItemFile';
    this.baseAPIService.headerToken = this.token;
    return this.baseAPIService.postFile(url, data);
  }

  downloadFile(uri: string) {
    const url = this.baseUrl + uri;
    this.baseAPIService.headerToken = this.token;
    this.baseAPIService.downloadFile(url);
  }
}
